/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { UserNamespaceAuthorization } from '../model/userNamespaceAuthorization';
import { UserNamespaceAuthorizationCreateRequest } from '../model/userNamespaceAuthorizationCreateRequest';
import { UserNamespaceAuthorizationUpdateRequest } from '../model/userNamespaceAuthorizationUpdateRequest';
import { UserNamespaceAuthorizations } from '../model/userNamespaceAuthorizations';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class UserNamespaceAuthorizationService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createUserNamespaceAuthorization
     * &lt;p&gt;Creates a new user namespace authorization.&lt;/p&gt; &lt;p&gt;The user ID field may be prefixed with a wildcard token character \&quot;*\&quot; to authorize multiple users access to the namespace. The wildcard only works for as a prefix to match the suffix of the user ID. If the wildcard appears anywhere other than the prefix, the user ID must match as-is. For example:&lt;/p&gt; &lt;ul&gt; &lt;li&gt;john.doe@domain.com - only authorizes user with ID \&quot;john.doe@domain.com\&quot;&lt;/li&gt; &lt;li&gt;*@domain.com - authorizes users that has the suffix \&quot;@domain.com\&quot;&lt;/li&gt; &lt;li&gt;* - authorizes all users&lt;/li&gt; &lt;li&gt;john.doe* - only authorizes user with ID \&quot;john.doe*\&quot;&lt;/li&gt; &lt;/ul&gt; &lt;p&gt;Requires GRANT permission on namespace&lt;/p&gt;
     * @param userNamespaceAuthorizationCreateRequest the information needed to create the user namespace authorization
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userNamespaceAuthorizationCreateUserNamespaceAuthorization(userNamespaceAuthorizationCreateRequest: UserNamespaceAuthorizationCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<UserNamespaceAuthorization>;
    public userNamespaceAuthorizationCreateUserNamespaceAuthorization(userNamespaceAuthorizationCreateRequest: UserNamespaceAuthorizationCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserNamespaceAuthorization>>;
    public userNamespaceAuthorizationCreateUserNamespaceAuthorization(userNamespaceAuthorizationCreateRequest: UserNamespaceAuthorizationCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserNamespaceAuthorization>>;
    public userNamespaceAuthorizationCreateUserNamespaceAuthorization(userNamespaceAuthorizationCreateRequest: UserNamespaceAuthorizationCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userNamespaceAuthorizationCreateRequest === null || userNamespaceAuthorizationCreateRequest === undefined) {
            throw new Error('Required parameter userNamespaceAuthorizationCreateRequest was null or undefined when calling userNamespaceAuthorizationCreateUserNamespaceAuthorization.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<UserNamespaceAuthorization>(`${this.configuration.basePath}/userNamespaceAuthorizations`,
            userNamespaceAuthorizationCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteUserNamespaceAuthorization
     * Deletes an existing user namespace authorization by key. &lt;p&gt;Requires GRANT permission on namespace&lt;/p&gt;
     * @param userId the user id
     * @param namespace the namespace
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userNamespaceAuthorizationDeleteUserNamespaceAuthorization(userId: string, namespace: string, observe?: 'body', reportProgress?: boolean): Observable<UserNamespaceAuthorization>;
    public userNamespaceAuthorizationDeleteUserNamespaceAuthorization(userId: string, namespace: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserNamespaceAuthorization>>;
    public userNamespaceAuthorizationDeleteUserNamespaceAuthorization(userId: string, namespace: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserNamespaceAuthorization>>;
    public userNamespaceAuthorizationDeleteUserNamespaceAuthorization(userId: string, namespace: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userNamespaceAuthorizationDeleteUserNamespaceAuthorization.');
        }
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling userNamespaceAuthorizationDeleteUserNamespaceAuthorization.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<UserNamespaceAuthorization>(`${this.configuration.basePath}/userNamespaceAuthorizations/userIds/${encodeURIComponent(String(userId))}/namespaces/${encodeURIComponent(String(namespace))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteUserNamespaceAuthorizationsByNamespace
     * Deletes all existing user namespace authorizations for the namespace.
     * @param namespace the namespace
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userNamespaceAuthorizationDeleteUserNamespaceAuthorizationsByNamespace(namespace: string, observe?: 'body', reportProgress?: boolean): Observable<UserNamespaceAuthorizations>;
    public userNamespaceAuthorizationDeleteUserNamespaceAuthorizationsByNamespace(namespace: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserNamespaceAuthorizations>>;
    public userNamespaceAuthorizationDeleteUserNamespaceAuthorizationsByNamespace(namespace: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserNamespaceAuthorizations>>;
    public userNamespaceAuthorizationDeleteUserNamespaceAuthorizationsByNamespace(namespace: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling userNamespaceAuthorizationDeleteUserNamespaceAuthorizationsByNamespace.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<UserNamespaceAuthorizations>(`${this.configuration.basePath}/userNamespaceAuthorizations/namespaces/${encodeURIComponent(String(namespace))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteUserNamespaceAuthorizationsByUserId
     * Deletes all existing user namespace authorizations for the specified user.
     * @param userId the user id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userNamespaceAuthorizationDeleteUserNamespaceAuthorizationsByUserId(userId: string, observe?: 'body', reportProgress?: boolean): Observable<UserNamespaceAuthorizations>;
    public userNamespaceAuthorizationDeleteUserNamespaceAuthorizationsByUserId(userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserNamespaceAuthorizations>>;
    public userNamespaceAuthorizationDeleteUserNamespaceAuthorizationsByUserId(userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserNamespaceAuthorizations>>;
    public userNamespaceAuthorizationDeleteUserNamespaceAuthorizationsByUserId(userId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userNamespaceAuthorizationDeleteUserNamespaceAuthorizationsByUserId.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<UserNamespaceAuthorizations>(`${this.configuration.basePath}/userNamespaceAuthorizations/userIds/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getUserNamespaceAuthorization
     * Gets an existing user namespace authorization by key. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param userId the user id
     * @param namespace the namespace
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userNamespaceAuthorizationGetUserNamespaceAuthorization(userId: string, namespace: string, observe?: 'body', reportProgress?: boolean): Observable<UserNamespaceAuthorization>;
    public userNamespaceAuthorizationGetUserNamespaceAuthorization(userId: string, namespace: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserNamespaceAuthorization>>;
    public userNamespaceAuthorizationGetUserNamespaceAuthorization(userId: string, namespace: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserNamespaceAuthorization>>;
    public userNamespaceAuthorizationGetUserNamespaceAuthorization(userId: string, namespace: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userNamespaceAuthorizationGetUserNamespaceAuthorization.');
        }
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling userNamespaceAuthorizationGetUserNamespaceAuthorization.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<UserNamespaceAuthorization>(`${this.configuration.basePath}/userNamespaceAuthorizations/userIds/${encodeURIComponent(String(userId))}/namespaces/${encodeURIComponent(String(namespace))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getUserNamespaceAuthorizationsByNamespace
     * Gets a list of user namespace authorizations for the specified namespace.
     * @param namespace the namespace
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userNamespaceAuthorizationGetUserNamespaceAuthorizationsByNamespace(namespace: string, observe?: 'body', reportProgress?: boolean): Observable<UserNamespaceAuthorizations>;
    public userNamespaceAuthorizationGetUserNamespaceAuthorizationsByNamespace(namespace: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserNamespaceAuthorizations>>;
    public userNamespaceAuthorizationGetUserNamespaceAuthorizationsByNamespace(namespace: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserNamespaceAuthorizations>>;
    public userNamespaceAuthorizationGetUserNamespaceAuthorizationsByNamespace(namespace: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling userNamespaceAuthorizationGetUserNamespaceAuthorizationsByNamespace.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<UserNamespaceAuthorizations>(`${this.configuration.basePath}/userNamespaceAuthorizations/namespaces/${encodeURIComponent(String(namespace))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getUserNamespaceAuthorizationsByUserId
     * Gets a list of user namespace authorizations for the specified user.
     * @param userId the user id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userNamespaceAuthorizationGetUserNamespaceAuthorizationsByUserId(userId: string, observe?: 'body', reportProgress?: boolean): Observable<UserNamespaceAuthorizations>;
    public userNamespaceAuthorizationGetUserNamespaceAuthorizationsByUserId(userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserNamespaceAuthorizations>>;
    public userNamespaceAuthorizationGetUserNamespaceAuthorizationsByUserId(userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserNamespaceAuthorizations>>;
    public userNamespaceAuthorizationGetUserNamespaceAuthorizationsByUserId(userId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userNamespaceAuthorizationGetUserNamespaceAuthorizationsByUserId.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<UserNamespaceAuthorizations>(`${this.configuration.basePath}/userNamespaceAuthorizations/userIds/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateUserNamespaceAuthorization
     * Updates an existing user namespace authorization by key. &lt;p&gt;Requires GRANT permission on namespace&lt;/p&gt;
     * @param userId the user id
     * @param namespace the namespace
     * @param userNamespaceAuthorizationUpdateRequest the information needed to update the user namespace authorization
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userNamespaceAuthorizationUpdateUserNamespaceAuthorization(userId: string, namespace: string, userNamespaceAuthorizationUpdateRequest: UserNamespaceAuthorizationUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<UserNamespaceAuthorization>;
    public userNamespaceAuthorizationUpdateUserNamespaceAuthorization(userId: string, namespace: string, userNamespaceAuthorizationUpdateRequest: UserNamespaceAuthorizationUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserNamespaceAuthorization>>;
    public userNamespaceAuthorizationUpdateUserNamespaceAuthorization(userId: string, namespace: string, userNamespaceAuthorizationUpdateRequest: UserNamespaceAuthorizationUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserNamespaceAuthorization>>;
    public userNamespaceAuthorizationUpdateUserNamespaceAuthorization(userId: string, namespace: string, userNamespaceAuthorizationUpdateRequest: UserNamespaceAuthorizationUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling userNamespaceAuthorizationUpdateUserNamespaceAuthorization.');
        }
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling userNamespaceAuthorizationUpdateUserNamespaceAuthorization.');
        }
        if (userNamespaceAuthorizationUpdateRequest === null || userNamespaceAuthorizationUpdateRequest === undefined) {
            throw new Error('Required parameter userNamespaceAuthorizationUpdateRequest was null or undefined when calling userNamespaceAuthorizationUpdateUserNamespaceAuthorization.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<UserNamespaceAuthorization>(`${this.configuration.basePath}/userNamespaceAuthorizations/userIds/${encodeURIComponent(String(userId))}/namespaces/${encodeURIComponent(String(namespace))}`,
            userNamespaceAuthorizationUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
